import { getLogger } from "@/utils/logger";
import { Camera, CameraResultType, Photo } from "@capacitor/camera";
import { useCallback, useState } from "react";

const log = getLogger("app:hooks:camera");

export function useTakePicture() {
  const [state, setState] = useState<Photo | null>(null);

  const takePicture = useCallback(async () => {
    try {
      const image = await Camera.getPhoto({
        quality: 80,
        allowEditing: false,
        resultType: CameraResultType.Base64,
      });

      setState(image);
      return image;
    } catch (err) {
      log("Error: taking picture", err);
      setState(null);
      return null;
    }
  }, []);

  return {
    takePicture,
    photo: state,
  };
}
